import { render, staticRenderFns } from "./ProductComponentsDefinition.vue?vue&type=template&id=3ff565c6&"
import script from "./ProductComponentsDefinition.vue?vue&type=script&lang=js&"
export * from "./ProductComponentsDefinition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports